/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'contacts': {
    width: 18,
    height: 20,
    viewBox: '0 0 18 20',
    data: '<path pid="0" d="M7 14a2.793 2.793 0 013-3 2.793 2.793 0 013 3H7zm5-6a2 2 0 11-2-2 2 2 0 012 2zm4-8H4a2 2 0 00-2 2v2H0v2h2v3H0v2h2v3H0v2h2v2a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2zM4 18v-2h1v-2H4v-3h1V9H4V6h1V4H4V2h12v16H4z" _fill="#474950" fill-rule="evenodd"/>'
  }
})
